function initProductForm(root, productData, currentVariantId, opts) {
  root = root || document;
  opts = opts || {};
  var updateUrl = opts.updateUrl !== false;

  console.log('🎯 === PRODUCT PAGE INITIALIZATION ===');

  // ============================================
  // ELEMENT REFERENCES
  // ============================================

  const productForm = root.querySelector('#product-form');
  const mainImageContainer = root.querySelector('#main-image-container');
  /* The gallery is a <card-gallery> scroll-snap track (varali-card-gallery.js),
     the same engine the product cards use. Everything below drives it through
     gallery.goTo() and follows it via 'card-gallery:change' — nothing swaps an
     image src any more. */
  const gallery = root.querySelector('.product-gallery');
  const gallerySlides = gallery ? Array.from(gallery.querySelectorAll('.product-gallery__slide')) : [];
  const thumbnails = root.querySelectorAll('.thumbnail-item');
  const thumbnailsContainer = root.querySelector('.product-thumbnails');
  const prevButton = root.querySelector('#prev-image');
  const nextButton = root.querySelector('#next-image');
  const zoomButton = root.querySelector('#zoom-button');
  const zoomModal = root.querySelector('#image-zoom-modal');
  const zoomClose = root.querySelector('#zoom-close');
  const zoomedImage = root.querySelector('#zoom-image');
  const zoomPrevBtn = root.querySelector('#zoom-prev');
  const zoomNextBtn = root.querySelector('#zoom-next');
  const thumbnailPrevBtn = root.querySelector('#thumbnail-prev');
  const thumbnailNextBtn = root.querySelector('#thumbnail-next');

  // ============================================
  // VARIABLES
  // ============================================

  let currentImageIndex = 0;
  let currentVariant = null;
  let scrollPosition = 0;

  console.log('📦 Product Data:', productData);
  console.log('🆔 Initial Variant ID:', currentVariantId);

  // ============================================
  // VARIANT SELECTION - DAWN THEME COMPATIBLE
  // ============================================

  if (productData && productData.variants && currentVariantId) {
    currentVariant = productData.variants.find(v => v.id == currentVariantId);
    console.log('✅ Initial variant loaded:', currentVariant ? currentVariant.title : 'Not found');
  }

  const variantInputs = productForm ? productForm.querySelectorAll('input[type="radio"]') : [];
  console.log('🔘 Found', variantInputs.length, 'variant selectors');

  variantInputs.forEach(input => {
    input.addEventListener('change', handleVariantChange);
  });

  function handleVariantChange(e) {
    console.log('🔄 === VARIANT CHANGED ===');
    console.log('Option:', e.target.name, '=', e.target.value);

    const selectedValues = [];
    variantInputs.forEach(input => {
      if (input.checked) {
        selectedValues.push(input.value);
        console.log('✅ Selected:', input.value);
      }
    });

    const matchingVariant = productData.variants.find(variant => {
      const matches = selectedValues.every(value =>
        variant.options.some(option => option.toLowerCase() === value.toLowerCase())
      );
      return matches && variant.options.length === selectedValues.length;
    });

    if (matchingVariant) {
      console.log('✅ MATCHED VARIANT:', matchingVariant.id, '-', matchingVariant.title);
      currentVariant = matchingVariant;
      updateProductDisplay(matchingVariant);
    } else {
      console.error('❌ No variant found for:', selectedValues);
    }
  }

  function updateProductDisplay(variant) {
    console.log('🎨 === UPDATING UI ===');
    console.log('Variant ID:', variant.id);
    console.log('Available:', variant.available);

    showVariantMedia(variant);

    const priceEl = root.querySelector('#variant-price');
    const comparePriceEl = root.querySelector('#variant-compare-price');

    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    const skuEl = root.querySelector('#variant-sku');
    if (skuEl && variant.sku) {
      skuEl.textContent = variant.sku;
    }

    const hiddenInput = root.querySelector('#variant-id');

    if (hiddenInput) {
      hiddenInput.value = variant.id;
      console.log('✅✅✅ Hidden input set to:', variant.id);
    } else {
      console.error('❌❌❌ Hidden input NOT FOUND');
    }

    const addBtn = root.querySelector('#add-to-cart-btn');

    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      addBtn.style.background = '';
      console.log(variant.available ? '✅ Button ENABLED' : '⚠️ Button DISABLED');
    }

    variantInputs.forEach(input => {
      if (input.checked) {
        const displayEl = root.querySelector(`#selected-${input.name}`);
        if (displayEl) displayEl.textContent = input.value;
      }
    });

    const stockEl = root.querySelector('#stock-status');
    if (stockEl && variant.inventory_management) {
      if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
        stockEl.textContent = `Last ${variant.inventory_quantity} left`;
        stockEl.classList.add('low-stock');
        stockEl.style.display = 'block';
      } else if (variant.inventory_quantity > 10) {
        stockEl.textContent = 'In stock';
        stockEl.classList.remove('low-stock');
        stockEl.style.display = 'block';
      } else {
        stockEl.style.display = 'none';
      }
    }

    if (updateUrl && root === document && window.history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    console.log('✅ UI update complete');
  }

  if (currentVariant) {
    updateProductDisplay(currentVariant);
  }

  // ============================================
  // FORM SUBMISSION - ADD TO CART
  // ============================================

  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      console.log('🛒 === FORM SUBMITTED ===');

      const hiddenInput = root.querySelector('#variant-id');
      const variantId = hiddenInput ? hiddenInput.value : null;

      console.log('📦 Variant ID from form:', variantId);

      if (!variantId || variantId === '') {
        console.error('❌ NO VARIANT ID');
        alert('Please select a size/variant before adding to cart.');
        return false;
      }

      const addBtn = root.querySelector('#add-to-cart-btn');
      const originalText = addBtn ? addBtn.textContent : 'ADD TO CART';
      const originalBg = addBtn ? addBtn.style.background : '';

      if (addBtn) {
        addBtn.textContent = 'ADDING...';
        addBtn.disabled = true;
      }

      const requestBody = {
        id: variantId,
        quantity: 1
      };

      console.log('📤 Sending to Shopify...');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestBody)
      })
      .then(response => {
        console.log('📥 Response:', response.status);

        if (!response.ok) {
          return response.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add to cart');
          });
        }

        return response.json();
      })
      .then(data => {
        console.log('✅ SUCCESS:', data);

        if (addBtn) {
          addBtn.textContent = 'ADDED ✓';
          addBtn.style.background = '#28a745';
        }

        // Open the custom cart drawer — NEVER navigate away from the page
        if (typeof window.vcdOpen === 'function') {
          window.vcdOpen();
        } else {
          console.warn('⚠️ vcdOpen not available — cart drawer did not open');
        }

        if (typeof opts.onAdded === 'function') opts.onAdded(data);

        // Restore the button so the customer can add again
        setTimeout(() => {
          if (addBtn) {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
            addBtn.style.background = originalBg;
          }
        }, 1200);
      })
      .catch(error => {
        console.error('❌ ERROR:', error);

        if (addBtn) {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
          addBtn.style.background = originalBg;
        }

        alert('Error adding to cart. Please try again.');
      });

      return false;
    });

    console.log('✅ Form submit handler attached');
  }

  // ============================================
  // THUMBNAIL NAVIGATION
  // ============================================

  if (thumbnailsContainer && thumbnailPrevBtn && thumbnailNextBtn && window.innerWidth >= 750) {
    function updateThumbnailArrows() {
      const scrollLeft = thumbnailsContainer.scrollLeft;
      const maxScroll = thumbnailsContainer.scrollWidth - thumbnailsContainer.clientWidth;

      thumbnailPrevBtn.disabled = scrollLeft <= 1;
      thumbnailPrevBtn.style.opacity = scrollLeft <= 1 ? '0.3' : '1';

      thumbnailNextBtn.disabled = scrollLeft >= maxScroll - 1;
      thumbnailNextBtn.style.opacity = scrollLeft >= maxScroll - 1 ? '0.3' : '1';
    }

    thumbnailPrevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      thumbnailsContainer.scrollBy({ left: -200, behavior: 'smooth' });
      setTimeout(updateThumbnailArrows, 300);
    });

    thumbnailNextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      thumbnailsContainer.scrollBy({ left: 200, behavior: 'smooth' });
      setTimeout(updateThumbnailArrows, 300);
    });

    thumbnailsContainer.addEventListener('scroll', updateThumbnailArrows);
    setTimeout(updateThumbnailArrows, 500);
  }

  // ============================================
  // IMAGE PRELOADING
  // ============================================

  /* No manual preloading here any more. Every media item is a real <img> in
     the track with width/height and lazy loading, and the gallery engine
     promotes the slides either side of the current one to eager as you move —
     so images are ready before they scroll in without fetching the whole strip
     up front the way this used to. */

  // ============================================
  // THUMBNAIL CLICKS
  // ============================================

  thumbnails.forEach((thumb) => {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      const newIndex = parseInt(this.getAttribute('data-media-index'));
      if (newIndex !== currentImageIndex) goToImage(newIndex);
    });
  });

  /* Single source of truth for the current slide: the track. Scrolling it —
     by swipe, mouse drag, trackpad, dot or key — fires this, so the thumbnails
     stay in sync no matter which input moved it. The dots are wired straight
     into the engine via data-card-gallery-dot and need nothing here. */
  if (gallery) {
    gallery.addEventListener('card-gallery:change', (event) => {
      currentImageIndex = event.detail.index;
      updateActiveThumbnail();
    });
  }

  function goToImage(index) {
    // gallery.ready is false for single-media products: the element is in the
    // markup but there is nothing to scroll, so drive the state directly.
    if (gallery && gallery.ready) {
      gallery.goTo(index);
      return;
    }
    currentImageIndex = index;
    updateActiveThumbnail();
  }

  /* Jump to a variant's own image when one is assigned. The slides carry
     data-media-id, so the variant's featured_media resolves to a slide index
     without depending on media order. */
  function showVariantMedia(variant) {
    if (!variant || !variant.featured_media || !gallerySlides.length) return;

    const mediaId = String(variant.featured_media.id);
    const index = gallerySlides.findIndex((slide) => slide.dataset.mediaId === mediaId);
    if (index >= 0 && index !== currentImageIndex) goToImage(index);
  }

  // ============================================
  // MAIN IMAGE NAVIGATION
  // ============================================

  if (prevButton) {
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      navigateToPrevious();
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      navigateToNext();
    });
  }

  /* The mobile dots carry data-card-gallery-dot, so the gallery engine owns
     their clicks and their active state directly.

     The old touch handlers are gone with them. They were a flick detector:
     50px of travel in under 300ms, then a jump to the next src. The track
     scrolls with the finger instead — image follows the gesture 1:1, rubber-
     bands at the ends, and a vertical drag still scrolls the page because
     nothing here calls preventDefault on a touch. */

  /* The arrows this design already had stay — the brief was not to introduce
     new ones. They page the same track everything else does. Wrapping is kept
     from the previous behaviour, but the track itself is clamped, so a wrap
     lands on the real first/last slide. */
  function slideCount() {
    return gallerySlides.length || 1;
  }

  function navigateToPrevious() {
    goToImage((currentImageIndex - 1 + slideCount()) % slideCount());
  }

  function navigateToNext() {
    goToImage((currentImageIndex + 1) % slideCount());
  }

  function updateActiveThumbnail() {
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === currentImageIndex);
    });

    const activeThumbnail = thumbnails[currentImageIndex];
    if (!activeThumbnail || !thumbnailsContainer) return;

    /* Scroll the thumbnail strip itself rather than calling scrollIntoView on
       the thumbnail. This now runs on every swipe, not just on a click, and
       scrollIntoView walks every scrollable ancestor — including the page —
       which is a jump waiting to happen mid-gesture. */
    const target =
      activeThumbnail.offsetLeft -
      (thumbnailsContainer.clientWidth - activeThumbnail.clientWidth) / 2;

    thumbnailsContainer.scrollTo({
      left: Math.max(0, target),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  // ============================================
  // ZOOM MODAL
  // ============================================

  if (zoomButton) {
    zoomButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openZoomModal();
    });
  }

  if (mainImageContainer) {
    /* No drag guard needed here. A click that ends a mouse drag is killed by
       the gallery in the capture phase, which stops it reaching this listener
       on the wrapper above the track — so dragging through images never opens
       the zoom modal. */
    mainImageContainer.addEventListener('click', (e) => {
      if (e.target.closest('.image-zoom-button, .image-nav-arrow, .pagination-dot')) return;
      if (window.innerWidth >= 750) openZoomModal();
    });
  }

  /* Zoom follows the track rather than one fixed <img>: whichever slide is on
     screen supplies the full-size source. */
  function currentImage() {
    const slide = gallerySlides[currentImageIndex];
    return slide ? slide.querySelector('img') : root.querySelector('#main-product-image');
  }

  function openZoomModal() {
    const image = currentImage();
    if (!zoomModal || !zoomedImage || !image) return;

    scrollPosition = window.pageYOffset;
    const fullSizeUrl = image.dataset.zoomSrc || image.src.replace(/_\d+x/, '_1500x');

    zoomedImage.src = fullSizeUrl;
    zoomedImage.alt = image.alt;
    zoomModal.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.left = '0';
    document.body.style.right = '0';
  }

  function closeZoomModal() {
    if (!zoomModal) return;

    zoomModal.classList.remove('active');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, scrollPosition);
  }

  if (zoomClose) {
    zoomClose.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeZoomModal();
    });
  }

  if (zoomModal) {
    zoomModal.addEventListener('click', (e) => {
      if (e.target === zoomModal) closeZoomModal();
    });

    if (window.innerWidth < 750) {
      let tapTimeout;
      zoomModal.addEventListener('touchend', (e) => {
        if (e.target.closest('.zoom-nav-arrow, .zoom-close, img')) return;

        clearTimeout(tapTimeout);
        tapTimeout = setTimeout(() => {
          closeZoomModal();
        }, 100);
      });
    }
  }

  function handleZoomKeydown(e) {
    if (zoomModal && zoomModal.classList.contains('active')) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeZoomModal();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        navigateToPrevious();
        updateZoomedImage();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        navigateToNext();
        updateZoomedImage();
      }
    }
  }

  document.addEventListener('keydown', handleZoomKeydown);

  if (zoomPrevBtn) {
    zoomPrevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      navigateToPrevious();
      updateZoomedImage();
    });
  }

  if (zoomNextBtn) {
    zoomNextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      navigateToNext();
      updateZoomedImage();
    });
  }

  function updateZoomedImage() {
    // Deferred a frame so the track has settled on the new slide first.
    setTimeout(() => {
      const image = currentImage();
      if (!zoomedImage || !image || !image.dataset.zoomSrc) return;
      zoomedImage.src = image.dataset.zoomSrc;
      zoomedImage.alt = image.alt;
    }, 50);
  }

  if (zoomModal) {
    zoomModal.addEventListener('touchmove', (e) => {
      if (e.target === zoomModal) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  // ============================================
  // UTILITY FUNCTIONS
  // ============================================

  function formatMoney(cents) {
    const amount = cents / 100;
    return 'Rs. ' + amount.toFixed(2).replace(/\.00$/, '');
  }

  console.log('✅ === ALL SYSTEMS READY ===');

  return {
    destroy: function () {
      document.removeEventListener('keydown', handleZoomKeydown);
    }
  };
}

document.addEventListener('DOMContentLoaded', function() {
  // This file can be requested by more than one section on the same page
  // (each card-product.liquid render loop loads it independently) — guard
  // against initializing the real PDP form twice.
  if (window.__mainProductFormInitialized) return;
  window.__mainProductFormInitialized = true;
  initProductForm(document, window.productJSON, window.currentVariantId, { updateUrl: true });
});

window.initProductForm = initProductForm;
